<template>
  <v-container class="pt-10 pb-16 page-privacy">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <!-- PAGE TITLE -->
        <h1 class="page-title mb-4">SERVICE PARTNER PRIVACY POLICY (INDIA)</h1>

        <p class="mb-1">
          <strong>Operating Entity:</strong> Gigvoc Technologies Private Limited
        </p>
        <p class="mb-1">
          <strong>Platform:</strong> OhYes Mobile App & Website
        </p>
        <p class="mb-6"><strong>Effective Date:</strong> January 21, 2026</p>

        <!-- 1 -->
        <section>
          <h3>1. INTRODUCTION</h3>
          <p>
            Gigvoc Technologies Private Limited ("Gigvoc," "we," "us") is
            committed to managing the digital personal data of our Service
            Partners ("Data Principals") with high standards of transparency.
            This policy explains how we collect, process, and protect your
            professional and personal data.
          </p>
        </section>

        <!-- 2 -->
        <section>
          <h3>2. DATA WE COLLECT FROM PARTNERS</h3>
          <ul>
            <li>
              <strong>KYC & Identity Data:</strong>
              Full name, date of birth, and Aadhaar number for identity
              verification and e-Shram portal linking.
            </li>
            <li>
              <strong>Tax & Financial Data:</strong>
              PAN, bank account details for payouts, and GSTIN (if applicable).
            </li>
            <li>
              <strong>Professional Credentials:</strong>
              Trade licenses, certifications, and photos of previous work.
            </li>
            <li>
              <strong>Real-Time Geolocation:</strong>
              Precise location when marked as “Available” or “On Duty” to assign
              nearby leads and provide live tracking to Customers.
            </li>
            <li>
              <strong>Background Verification:</strong>
              Data from authorized third-party agencies relating to criminal
              records and professional history.
            </li>
          </ul>
        </section>

        <!-- 3 -->
        <section>
          <h3>3. STATUTORY DATA SHARING (SOCIAL SECURITY)</h3>
          <ul>
            <li>
              <strong>Government Portals:</strong>
              Verified Partner data is shared with the Central Government’s
              e-Shram portal in compliance with the Code on Social Security,
              2020.
            </li>
            <li>
              <strong>Benefit Eligibility:</strong>
              Engagement Days (days with platform earnings) are tracked to
              determine eligibility for government-backed social security,
              insurance, and health benefits.
            </li>
          </ul>
        </section>

        <!-- 4 -->
        <section>
          <h3>4. HOW WE USE YOUR DATA</h3>
          <ul>
            <li>
              <strong>Lead Matching:</strong>
              To notify you of service requests within your geographical range.
            </li>
            <li>
              <strong>Trust & Safety:</strong>
              Your name, profile photo, and ratings are shared with Customers
              upon booking.
            </li>
            <li>
              <strong>Payment Processing:</strong>
              To calculate earnings, deduct Platform Fees, and process direct
              bank transfers.
            </li>
            <li>
              <strong>Dispute Resolution:</strong>
              In-app chat logs and job completion photos are stored to resolve
              disputes.
            </li>
          </ul>
        </section>

        <!-- 5 -->
        <section>
          <h3>5. DATA PRINCIPAL RIGHTS (DPDP ACT 2023)</h3>
          <ul>
            <li>
              <strong>Right to Correction:</strong>
              Update contact details or bank information through the Partner
              App.
            </li>
            <li>
              <strong>Right to Erasure:</strong>
              Request deletion of data upon leaving the platform (subject to
              7-year statutory retention for GST and audits).
            </li>
            <li>
              <strong>Right to Nominate:</strong>
              Nominate an individual to manage your data and earnings in the
              event of death or incapacity.
            </li>
          </ul>
        </section>

        <!-- 6 -->
        <section>
          <h3>6. DATA RETENTION & SECURITY</h3>
          <ul>
            <li>
              <strong>Retention:</strong>
              Professional and financial records are retained for 7 years to
              comply with Indian income tax and GST laws.
            </li>
            <li>
              <strong>Security:</strong>
              Enterprise-grade encryption is used for Aadhaar and banking data.
              All data is stored on secure servers within India.
            </li>
          </ul>
        </section>

        <!-- 7 -->
        <section>
          <h3>7. GRIEVANCE REDRESSAL</h3>
          <p>
            For concerns related to data handling, you may contact our Grievance
            Officer:
          </p>
          <ul>
            <li><strong>Name:</strong> [Insert Name]</li>
            <li>
              <strong>Email:</strong>
              [Insert Email, e.g., partner.grievance@gigvoc.com]
            </li>
            <li>
              <strong>Timeline:</strong>
              Acknowledgement within 24 hours and resolution within 15 days.
            </li>
          </ul>
        </section>

        <!-- IMPLEMENTATION NOTES -->
        <section>
          <h3>Implementation Tips for Gigvoc Technologies (India)</h3>
          <ul>
            <li>
              Use an Aadhaar Vault with masking to comply with UIDAI security
              requirements.
            </li>
            <li>
              Integrate e-Shram registration during Partner onboarding to
              support social security eligibility.
            </li>
            <li>
              Display a clear in-app notification whenever location tracking is
              active (e.g., “You are now Online”).
            </li>
          </ul>
        </section>
      </v-col>
    </v-row>
  </v-container>
</template>
  
  <script>
export default {
  name: "PartnerPrivacyIndia",
};
</script>
  
  <style scoped>
.page-title {
  font-size: 34px;
  font-weight: 700;
}

section {
  margin-bottom: 28px;
}

h3 {
  font-size: 16px;
  font-weight: 600;
  margin-top: 18px;
  margin-bottom: 6px;
}

p,
li {
  font-size: 15px;
  color: #444;
  line-height: 1.7;
}

ul {
  padding-left: 20px;
}
</style>
  